module.exports = __webpack_public_path__ + "img/car-crash.c553a9a6.png";